export default class Chat {
    constructor(openNow) {
        this.customTriggers = Array.from(document.querySelectorAll('a[href="#chat"]'));
        const isTest = window.location.href.includes('?test-chat');
        if ((openNow || isTest) && !window.hideLAChat) {
            console.log('Chat is open');
            this.activateChat();
        } else {
            this.removeChatButtons();
        }
    }

    activateChat() {
        /* eslint-disable */
        // prettier-ignore
        (function (d, src, c) {var t = d.scripts[d.scripts.length - 1], s = d.createElement('script'); s.id = 'la_x2s6df8d'; s.async = true; s.src = src; s.onload = s.onreadystatechange = function () { var rs = this.readyState; if (rs && rs != 'complete' && rs != 'loaded') { return;} c(this);}; t.parentElement.insertBefore(s, t.nextSibling);
        })(document, 'https://healthpartners.ladesk.com/scripts/track.js', function (e) {
            window.chatButton = LiveAgent.createButton('63753c7d', e);
        });
        /* eslint-enable */
        this.setupChatButtons();
    }

    removeChatButtons() {
        this.customTriggers.forEach((btn) => btn.remove());
    }

    trackChatStart() {
        window.dataLayer.push({
            event: 'chatStart',
            url: window.location.href
        });
    }

    setupChatButtons() {
        window.setTimeout(() => {
            const button = document.querySelector('div[title="Live chat button"]');
            if (button) button.addEventListener('click', this.trackChatStart);

            this.customTriggers.forEach((btn) => {
                btn.addEventListener('click', () => {
                    // Trigger chat from custom button
                    window.chatButton.onClick();
                    this.trackChatStart();
                });
            });
        }, 2000);
    }
}
